import { request, RequestInitWithRetry } from '../../lib/request';

export type DeviceAnomalyEventName = 'deviceRebooted' | 'deviceDropped' | 'deviceLowPower' | 'processCrashed' | 'processHung';
export type DeviceAnomalyPeriod = 'training' | 'evaluation';

export interface IDeviceAnomalyChartParams {
  deviceId: string,
  timeZone: string,
  from: number,
  to: number
}

export interface IDeviceAnomalyEventParams extends IDeviceAnomalyChartParams {
  eventName: DeviceAnomalyEventName
}

export interface IDeviceAnomalyEventDataPoint {
  date: string,
  count: number,
  period: DeviceAnomalyPeriod,
  isAnomaly: boolean
}

export interface IDeviceAnomalyDataUsageDataPoint {
  date: string,
  wifi: number,
  mobile: number,
  period: DeviceAnomalyPeriod,
  isAnomaly: boolean
}

export function getDeviceAnomalyEventChart(params: IDeviceAnomalyEventParams) {
  return async (options: RequestInitWithRetry): Promise<IDeviceAnomalyEventDataPoint[]> => {
    const input = {
      path: '/api/core/anomalies-beta/devices/events',
      body: params,
      method: 'post'
    };
    return request(input, options);
  };
}

export function getDeviceAnomalyDataUsageChart(params: IDeviceAnomalyChartParams) {
  return async (options: RequestInitWithRetry): Promise<IDeviceAnomalyDataUsageDataPoint[]> => {
    const input = {
      path: '/api/core/anomalies-beta/devices/dataUsage',
      body: params,
      method: 'post'
    };
    return request(input, options);
  };
}
